<template>
  <p class="text-red-600 text-center">
    {{ message }}
  </p>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'MessageError',
  props: {
    message: {
      type: String,
      default: '',
    },
  },
});
</script>
